import CalendarEvent from './CalendarEvent';

export default CalendarEvent;
